/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Guest Guide',
  definitions: {
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path
            d="M9.93262 22.3857C9.93256 22.7308 9.65262 23.0106 9.30762 23.0107C8.96412 23.0107 8.67486 22.7325 8.6748 22.3857C8.67503 22.0408 8.95477 21.7607 9.2998 21.7607C9.64311 21.7607 9.93239 22.0393 9.93262 22.3857Z"
            fill="currentColor"
          />
          <path
            d="M23.332 22.3857C23.332 22.7521 23.0431 22.9769 22.707 23.0107H11.8535C11.5084 23.0107 11.2286 22.7309 11.2285 22.3857C11.2287 22.0408 11.5085 21.7607 11.8535 21.7607H22.707C23.0431 21.7946 23.3318 22.0194 23.332 22.3857Z"
            fill="currentColor"
          />
          <path
            d="M9.93262 18.1299C9.9324 18.4763 9.64311 18.7549 9.2998 18.7549C8.95476 18.7549 8.67502 18.4749 8.6748 18.1299C8.67503 17.7849 8.95477 17.5049 9.2998 17.5049C9.64311 17.5049 9.93239 17.7835 9.93262 18.1299Z"
            fill="currentColor"
          />
          <path
            d="M23.332 18.1299C23.3318 18.4962 23.0431 18.721 22.707 18.7549H11.8535C11.5085 18.7549 11.2287 18.4749 11.2285 18.1299C11.2287 17.7849 11.5085 17.5049 11.8535 17.5049H22.707C23.0431 17.5387 23.3318 17.7636 23.332 18.1299Z"
            fill="currentColor"
          />
          <path
            d="M9.43359 13.2607C9.71813 13.319 9.93228 13.5714 9.93262 13.873C9.93262 14.1749 9.71821 14.4269 9.43359 14.4854L9.2998 14.498C8.95463 14.498 8.6748 14.2182 8.6748 13.873C8.67519 13.5282 8.95486 13.248 9.2998 13.248L9.43359 13.2607Z"
            fill="currentColor"
          />
          <path
            d="M22.707 13.248C23.0517 13.2484 23.3316 13.5284 23.332 13.873C23.332 14.218 23.0519 14.4977 22.707 14.498H11.8535C11.5083 14.498 11.2285 14.2182 11.2285 13.873C11.2289 13.5282 11.5086 13.248 11.8535 13.248H22.707Z"
            fill="currentColor"
          />
          <path
            d="M9.43359 9.00488C9.71819 9.06319 9.93242 9.3154 9.93262 9.61719C9.93262 9.91911 9.71824 10.1711 9.43359 10.2295L9.2998 10.2422C8.95463 10.2422 8.6748 9.96237 8.6748 9.61719C8.67503 9.2722 8.95477 8.99219 9.2998 8.99219L9.43359 9.00488Z"
            fill="currentColor"
          />
          <path
            d="M20.7783 9.61719C20.7783 9.98359 20.4894 10.2083 20.1533 10.2422H11.8535C11.5083 10.2422 11.2285 9.96237 11.2285 9.61719C11.2287 9.2722 11.5085 8.99219 11.8535 8.99219H20.1533C20.4894 9.02606 20.7781 9.25084 20.7783 9.61719Z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.9092 0.68457C18.9292 0.706255 20.3049 0.799921 21.2412 0.917969C22.5663 1.08512 23.9143 1.97259 24.876 2.89941C25.9071 3.89324 27.2081 5.40647 28.1084 7.36523C28.2739 7.72529 28.3631 8.11377 28.3945 8.50879C28.62 11.3474 28.7851 14.19 28.7637 17.0381C28.6881 22.1381 28.0698 26.0303 27.6016 28.2812C27.265 29.6223 26.2567 30.6638 24.8467 30.8447L24.124 30.9307C22.3145 31.1321 19.6378 31.3242 16.0029 31.3242L14.4688 31.3125C11.5216 31.2667 9.30284 31.0932 7.75098 30.916L7.03027 30.8281C5.699 30.653 4.719 29.6939 4.38672 28.4219C3.92043 26.3182 3.31594 22.5779 3.24219 17.1172L3.23438 16.002C3.23438 10.7416 3.72579 6.95586 4.18066 4.5791L4.37207 3.64648C4.66886 2.29425 5.77405 1.40168 7.10254 1.18457C8.94222 0.94896 11.9344 0.679688 16.0029 0.679688L16.9092 0.68457ZM16.0029 1.92969C11.9898 1.92969 9.05092 2.19567 7.26172 2.4248C6.40863 2.53406 5.76806 3.11606 5.59277 3.91406C5.11663 6.08353 4.48438 10.0798 4.48438 16.002C4.48438 21.981 5.12882 25.9965 5.60645 28.1514C5.80609 28.9184 6.39229 29.4835 7.19336 29.5889L7.89258 29.6738C9.65366 29.8749 12.3244 30.0742 16.0029 30.0742C20.1065 30.0742 22.956 29.8265 24.6875 29.6045C25.54 29.4951 26.1986 28.8838 26.377 28.0264C27.155 24.0635 27.5215 20.0414 27.5215 16.002C27.5215 13.7768 27.3701 11.551 27.2021 9.33301L24.4756 9.10645C23.2626 9.00514 22.2895 8.08621 22.1016 6.9043L21.7852 2.33496C21.5568 2.25146 21.3241 2.19762 21.085 2.1582C20.086 2.03226 18.4989 1.92969 16.0029 1.92969ZM23.3213 6.58203C23.3995 7.24946 23.8856 7.80225 24.5791 7.86035L27.042 8.06445C27.022 8.00453 26.9964 7.94632 26.9727 7.8877C26.1579 6.11485 24.9686 4.72581 24.0078 3.7998C23.721 3.52335 23.4078 3.26629 23.085 3.03906L23.3213 6.58203Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
